import { AvatarGroup, AvatarGroupProps } from '@chakra-ui/react';
import { ProfileCard } from 'types/profile';
import { AvatarWithTooltip } from './AvatarWithTooltip';
import { AvatarDefault } from './AvatarDefault';

interface ChakraAvatarGroupProps {
  maxGroupSize: number;
  users: Partial<ProfileCard>[];
  size?: AvatarGroupProps['size'];
  withTooltip?: boolean;
}

export const ChakraAvatarGroup = ({
  maxGroupSize,
  users,
  size = 'xxs',
  withTooltip = false,
}: ChakraAvatarGroupProps) => {
  const avatars = users.slice(0, maxGroupSize);
  const groupedAvatars = users.slice(maxGroupSize);

  return (
    <AvatarGroup
      size={size}
      spacing="-0.66rem"
      max={withTooltip ? undefined : maxGroupSize}
      fontSize="sm"
      sx={{
        '.chakra-avatar__excess': {
          fontSize: 'xs',
          lineHeight: '15px',
          color: 'textSubdued',
          background: 'surface2',
        },
      }}
    >
      {avatars.map((userCard, index: number) => {
        const key = userCard.guid || userCard.displayName;
        const props = {
          index,
          key: `${key}-${index}`,
          userCard,
          usersLength: users.length,
        };
        return withTooltip ? (
          <AvatarWithTooltip {...props} />
        ) : (
          <AvatarDefault {...props} />
        );
      })}
      {withTooltip && groupedAvatars.length > 0 && (
        <AvatarWithTooltip
          index={maxGroupSize}
          usersLength={users.length}
          userCard={{
            displayName: groupedAvatars.map((a) => a.displayName).join(', '),
            initials: `+${groupedAvatars.length}`,
            avatarColors: {
              background: 'borderBase',
              text: 'textSubdued',
            },
          }}
          sx={{
            '& .chakra-avatar__initials': {
              fontSize: 'xs',
              fontWeight: 500,
            },
          }}
        />
      )}
    </AvatarGroup>
  );
};
